import React from "react";
import { useAuth } from "@/context/AuthContext";
import ConversationList from "@/components/messaging/ConversationList";
import PauseIncomingToggle from "@/components/messaging/PauseIncomingToggle";

const TalentMessages = () => {
    const { user } = useAuth();
    return (
        <div className="max-w-4xl mx-auto px-4 py-8 sm:py-10" data-testid="talent-messages-page">
            <div className="flex justify-end mb-4">
                <PauseIncomingToggle />
            </div>
            <ConversationList
                viewerRole="professional"
                viewerUserId={user?.user_id}
                title="Your messages"
                emptyLabel="No employer messages yet. Keep your Talent Passport sharp — recruiters only see verified-US passports."
            />
        </div>
    );
};

export default TalentMessages;
